import { render, staticRenderFns } from "./multiple-product.vue?vue&type=template&id=442e4b10&scoped=true&"
import script from "./multiple-product.vue?vue&type=script&lang=js&"
export * from "./multiple-product.vue?vue&type=script&lang=js&"
import style0 from "./multiple-product.vue?vue&type=style&index=0&id=442e4b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442e4b10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('442e4b10')) {
      api.createRecord('442e4b10', component.options)
    } else {
      api.reload('442e4b10', component.options)
    }
    module.hot.accept("./multiple-product.vue?vue&type=template&id=442e4b10&scoped=true&", function () {
      api.rerender('442e4b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/pro/form-template/multiple-product.vue"
export default component.exports